import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  feature: {
    borderRadius: theme.spacing(1),
    marginTop: '0px !important',
    marginBottom: theme.spacing(2),

    '&:before': {
      height: 0
    },
    '&:not(.Mui-expanded)': {
      margin: '16px 0px !important'
    }
  },
  featureTitle: {
    borderRadius: theme.spacing(1, 1, 0, 0),
    backgroundColor: darken(theme.palette.background.paper, 0.05),
    position: 'sticky',
    top: 100,
    zIndex: 2
  },
  lineItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0.5, 0),
  },
  lineItemWithBorder: {
    borderBottom: '1px dashed #d9d9d9'
  },
  value: {
    // maxWidth: '400px',
    //textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
  }
}
));

function ClaimReviewFeatures({ claim }) {
  const { t } = useTranslation();
  const classes = useStyles();

  // Defensive check for claim object and features array
  if (!claim || !claim.features || !Array.isArray(claim.features)) {
    return null;
  }

  return (
    <Grid >
      <Accordion key='claimDetail' defaultExpanded expanded className={classes.feature}>
        <AccordionSummary expandIcon={null} className={classes.featureTitle} style={{ pointerEvents: 'none' }}>
          <Typography variant="h4" color="textPrimary">{t('glass')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container direction="column" >
            {
              claim.features.map((part) => (
                <Grid key={part.partNumber} item >
                  <Grid container className={clsx(classes.lineItem, classes.lineItemWithBorder)}>
                    <Grid item xs={4}  >
                      <Typography variant="h5">
                        {t('partNumberSlashQuantity')}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} className={classes.value}>
                      <Typography variant="body1"   >
                        {`${part.partNumber} / ${part.quantity}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))
            }

            <Grid key={'note-title'} item >
              <Grid container className={clsx(classes.lineItem, classes.lineItemWithBorder)}>
                <Grid item xs={4}  >
                  <Typography variant="h5">
                    {t('notes')}
                  </Typography>
                </Grid>
                <Grid item xs={8} className={classes.value}>
                  <Typography variant="body1" className={classes.value} >
                    {claim.claimNotes || t('noNotesProvided')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid >


  )
}

ClaimReviewFeatures.propTypes = {
  claim: PropTypes.shape({
    featureKey: PropTypes.string,
    product: PropTypes.string,
    claimNotes: PropTypes.string,
    features: PropTypes.arrayOf(
      PropTypes.shape({
        partNumber: PropTypes.string,
        quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ])
      })
    )
  }),
}

export default ClaimReviewFeatures;
